import type { RuntimeConfig } from '../types';

let cached: RuntimeConfig | null = null;

export const configCache = {
  get(): RuntimeConfig | null {
    return cached;
  },
  set(config: RuntimeConfig): void {
    cached = config;
  },
  clear(): void {
    cached = null;
  },
};
